/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { invitationControllerAccept } from '../fn/invitation/invitation-controller-accept';
import { InvitationControllerAccept$Params } from '../fn/invitation/invitation-controller-accept';
import { invitationControllerCreate } from '../fn/invitation/invitation-controller-create';
import { InvitationControllerCreate$Params } from '../fn/invitation/invitation-controller-create';
import { invitationControllerFindOne } from '../fn/invitation/invitation-controller-find-one';
import { InvitationControllerFindOne$Params } from '../fn/invitation/invitation-controller-find-one';
import { InvitationResponse } from '../models/invitation-response';

@Injectable({ providedIn: 'root' })
export class InvitationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `invitationControllerCreate()` */
  static readonly InvitationControllerCreatePath = '/invitation/sources/abook';

  /**
   * Crea inviti da elementi selezionati dall'address book utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `invitationControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  invitationControllerCreate$Response(params: InvitationControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return invitationControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea inviti da elementi selezionati dall'address book utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `invitationControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  invitationControllerCreate(params: InvitationControllerCreate$Params, context?: HttpContext): Observable<void> {
    return this.invitationControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `invitationControllerFindOne()` */
  static readonly InvitationControllerFindOnePath = '/invitation/{identifier}';

  /**
   * Restituisce i dettagli di una invitation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `invitationControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  invitationControllerFindOne$Response(params: InvitationControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: InvitationResponse;
}>> {
    return invitationControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce i dettagli di una invitation.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `invitationControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  invitationControllerFindOne(params: InvitationControllerFindOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: InvitationResponse;
}> {
    return this.invitationControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: InvitationResponse;
}>): BaseResponse & {
'data'?: InvitationResponse;
} => r.body)
    );
  }

  /** Path part for operation `invitationControllerAccept()` */
  static readonly InvitationControllerAcceptPath = '/invitation/{identifier}/accept';

  /**
   * Marca l'invitation come 'accettata'.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `invitationControllerAccept()` instead.
   *
   * This method doesn't expect any request body.
   */
  invitationControllerAccept$Response(params: InvitationControllerAccept$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: InvitationResponse;
}>> {
    return invitationControllerAccept(this.http, this.rootUrl, params, context);
  }

  /**
   * Marca l'invitation come 'accettata'.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `invitationControllerAccept$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  invitationControllerAccept(params: InvitationControllerAccept$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: InvitationResponse;
}> {
    return this.invitationControllerAccept$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: InvitationResponse;
}>): BaseResponse & {
'data'?: InvitationResponse;
} => r.body)
    );
  }

}
